import React, { useEffect } from 'react'

const PageTitle = ({title}: {title: string}) => {
    useEffect(() => {
        document.title = `Nucleo - ${title}`;
    }, []);
    return null
}

export default PageTitle